// Loads /config.json once per page. Generated by CDK (or written by deploy
// script) at deploy time and served from S3+CloudFront with no-cache.
// All apps fetch this at boot to learn AWS resource IDs.

let cached = null;

export async function loadConfig() {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json fetch failed: ${res.status}`);
  cached = await res.json();
  return cached;
}

// Shape:
// {
//   region: 'us-east-1',
//   iotEndpoint: 'a1b2c3d4-ats.iot.us-east-1.amazonaws.com',
//   identityPoolId: 'us-east-1:xxx',
//   userPoolId: 'us-east-1_xxx',
//   userPoolClientId: 'xxx',
//   decksBucket: 'reveal-sync-decks-NNNN',
//   site: 'https://slides.polarizationresearchlab.org'
// }
